<script>
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast/src';
import emojiData from 'emoji-mart-vue-fast/data/all-lean.json';
import emojiKeywords from 'emoji-mart-vue-fast/data/keywords.json';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import './emojiMartTheme.scss';

// EmojiIndex's constructor mutates then freezes the data, so building
// it per-instance breaks under HMR (frozen JSON imports get reused).
// One shared instance keeps it stable and lets all pickers share a
// recents list via the fork's refreshRecent() path.
const sharedEmojiIndex = new EmojiIndex(JSON.parse(JSON.stringify(emojiData)), { keywords: emojiKeywords });

export default {
  name: 'EmojiPicker',
  components: { Picker },
  props: {
    i18n: {
      type: Object,
      default: () => ({}),
    },
  },
  // Non-reactive instance prop. `data()` would make Vue 2 walk every
  // key of the (huge) index for reactivity.
  created() {
    this.emojiIndex = sharedEmojiIndex;
  },
  computed: {
    pickerI18n() {
      return {
        search: this.i18n.search || 'Search',
        notfound: this.i18n.notfound || 'No emoji found',
        categories: {
          search: 'Search results',
          recent: 'Recently used',
          smileys: 'Smileys & emotion',
          people: 'People & body',
          nature: 'Animals & nature',
          foods: 'Food & drink',
          activity: 'Activities',
          places: 'Travel & places',
          objects: 'Objects',
          symbols: 'Symbols',
          flags: 'Flags',
          custom: 'Custom',
          ...(this.i18n.categories || {}),
        },
      };
    },
  },
  methods: {
    onSelect(emoji) {
      this.$emit('select', emoji.native);
    },
  },
};
</script>

<template>
  <Picker
    :data="emojiIndex"
    :native="true"
    :show-preview="false"
    :show-skin-tones="true"
    :per-line="8"
    :emoji-size="22"
    :i18n="pickerI18n"
    title=""
    @select="onSelect"
  />
</template>
